// DateRangePickerExample.js
import React, { useState } from 'react';
import DateRangePicker from 'react-daterange-picker';
import 'react-daterange-picker/dist/css/react-calendar.css';
import moment from 'moment';

const DateRangePickerExample = () => {
  const [range, setRange] = useState(null);



  return (
    <div style={{ padding: '20px' }}>
      <h3>Select a date range:</h3>
      <DateRangePicker
        value={range}
        onSelect={setRange}
      />
      <div style={{ marginTop: '10px' }}>
        {range ? (
          <div>
            <strong>Start:</strong> {range.start.format('YYYY-MM-DD')} <br />
            <strong>End:</strong> {range.end.format('YYYY-MM-DD')}
          </div>
        ) : (
          'No date selected'
        )}
      </div>
    </div>
  );
};

export default DateRangePickerExample;
